module.exports = __webpack_public_path__ + "assets/img/HR-Connect-Website-w540.ec4523fd.jpg";